"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (property) {
  return property.match(/^(Webkit|Moz|O|ms)/) !== null;
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/inline-style-prefixer/lib/utils/isPrefixedProperty.js
// module id = 469
// module chunks = 0